import { NgModule } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { ButtonComponent } from './button.component';

@NgModule({
  declarations: [ButtonComponent],
  imports: [ButtonModule],
  exports: [ButtonComponent],
})
export class ButtonComponentModule {}
